import React from "react";
import { Link } from "react-router-dom";
import { getDefaultAuthenticatedPath, useAuth } from "../../core/context/AuthContext";
import taskMantisLockupDark from "../task-mantis-lockup-dark-bg.svg";
import taskMantisIconPurple from "../task-mantis-icon-purple.svg";

/**
 * Task Mantis logo in the business sidebar (full wordmark expanded, icon when collapsed).
 *
 * @example
 * <BusinessSidebarBrand collapsed={false} />
 */
const BusinessSidebarBrand = ({ collapsed = false }) => {
  const { selectedMode } = useAuth();
  const homePath = getDefaultAuthenticatedPath(selectedMode);

  return (
    <Link
      to={homePath}
      className={`business-sidebar-brand${collapsed ? " business-sidebar-brand--collapsed" : ""}`}
      title="Task Mantis"
    >
      <img
        src={collapsed ? taskMantisIconPurple : taskMantisLockupDark}
        alt="Task Mantis"
        className="business-sidebar-brand__logo"
      />
    </Link>
  );
};

export default BusinessSidebarBrand;
